module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-03.222e1f0.jpg";